(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name message.controller:MessageCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('message')
		.directive('focusOn',function($timeout) {
			return {
				restrict : 'A',
				link : function(vm,$element,$attr) {
					vm.$watch($attr.focusOn,function(_focusVal) {
						$timeout(function() {
							_focusVal ? $element[0].focus() : $element[0].blur();
						});
					});
				}
			}
		})
		.controller('AlertManagerCtrl', AlertManagerCtrl);

	function AlertManagerCtrl(CommonMasterData, AlertManagerService,CommonLogicService,
			crewScheduleService, applicationConstants, EventManagerService,PopupManager,
			MessageService,$timeout,StorageServices,UserActivityAuditReportService) {

		var vm = this;
		vm.ctrlName = 'AlertManagerCtrl';

		vm.model = {
      isElasticLoadingVisible:false,
      searchOnGoing:false,
			searchPanelToggle : true,
			searchCriteria : {
				isShowAllAlerts : false,
        isAffectedDutyDate : true
			},
			masterList : {
				crewBaseList : [],
				crewTypes : [],
				categoryList : [],
				aircraftTypes : [],
				crewDetails : [],
        alertCreatedByList : [],
        alertTemplateCodeList : [],
				maxCharactersInMSG : 0
			},
			alertList : [],//grid data
			initialSearchDone : false,
			editorMode : applicationConstants.EDITOR_STATUS.ADD,
			newSMS : null,
			allAlertSelected : false,
			smsToSend : null,
			selectedAlertsForMarkAsInform : [], //set only the selected not handled alerts
			selectedAlertsForSendAll : [],//set only the selected crew Alerts
			selectedAlert : null,
			showRightPanel : false,
			recordChange : false,
			sendSMSRequest : null,
      lastScrollPosition : 0
		};

    EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

    // to hide and show search panel
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// to hide and show new Alert panel
		vm.clickOnNewSMS = function() {
			vm.smsToSend = vm.newSMS;
			vm.model.showRightPanel = !vm.model.showRightPanel;
			if (vm.model.masterList.maxCharactersInMSG === 0) {
				getMaxCharCountInSentMsg();searchMethordDatsearchMethordDate
			}
		};

		// submit search and set search results
		vm.submitSearchAlerts = function(params) {
			vm.model.initialSearchDone = true;
			vm.model.alertList = [];
			vm.model.searchCriteria = params;
      vm.model.lastScrollPosition = 0;
      setDefault();
			getAlerts();
		};

    function setDefault() {
      vm.model.searchCriteria.pageSize = 100;
      vm.model.searchCriteria.startPosition = 1;
    }

		//when click on a row send button
		vm.doAction = function (event,index,selectedRowData, flag) {
            if (flag==='send'){
            	vm.model.selectedAlert = selectedRowData;
            	vm.model.newSMS = AlertManagerService.setSMSToEdit(vm.model.selectedAlert);
            	if(vm.model.newSMS.category == "Crew Alerts"){
            	  vm.model.showRightPanel = true;
            	}else if (vm.model.newSMS.category == "System Alerts"){
            	  var param = {
                  joiningCrew : vm.model.newSMS.crew,
                  messageContent : vm.model.newSMS.content
                };
                PopupManager.openModal('SMS', param, onSendSmsClose);
            	}
            }else if (flag==='markAsInformed'){
            	vm.model.selectedAlert = selectedRowData;
            	markAsInformed(vm.model.selectedAlert);
            }else if (flag==='selectAll'){
            	setAllAlertsAsSelected();
            }else if(flag=='checkSelect'){
            	//set elements to set as informed list
            	if(selectedRowData.isHandled=='N'){
            		addElementToAlertList(vm.model.selectedAlertsForMarkAsInform,selectedRowData);
	        	}else{
	        		removeElementFromAlertList(vm.model.selectedAlertsForMarkAsInform,selectedRowData)
	        	}
            	//set elements to send all list
            	if(selectedRowData.category =='Crew Alerts' || selectedRowData.category =='System Alerts'){
            		addElementToAlertList(vm.model.selectedAlertsForSendAll,selectedRowData);
	        	}else{
	        		removeElementFromAlertList(vm.model.selectedAlertsForSendAll,selectedRowData)
	        	}
            }
        };

        function isExistInList(list, alert){
        	return (list.indexOf(alert) >= 0) ? true : false;
        }

        function onSendSmsClose(crewId) {
          if (!!crewId) {
            createLocalStorageVariable(vm.model.crewDTO.crewId);
//            loadActualSchedule(false, undefined, 'Y');
          }
        }

        //add only selected elements
        function addElementToAlertList(list, alert){
        	if(!isExistInList(list, alert) && alert.isSelected){
        		list.push(alert)
        	}else if(!alert.isSelected){//remove existing not selected
        		removeElementFromAlertList(list, alert);
        	}
        }
        //remove existing elements
        function removeElementFromAlertList(list, alert){
        	if(isExistInList(list, alert)){
        		list.splice(list.indexOf(alert), 1 );
        	}
        }

		// close right panel
		vm.closeRightPanel = function() {
			vm.model.showRightPanel = false;
			vm.model.recordChange = false;
		};

		//add New SMS
		vm.addNewSMS = function() {
			vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
			vm.model.newSMS = AlertManagerService.getSMSToSend();
			vm.clickOnNewSMS();
		};

		//set selected alert
        vm.selectedAlert = function (alert) {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
            vm.model.selectedAlert = AlertManagerService.setAlertForEdit(alert);
			vm.model.showRightPanel = true;
			if (vm.model.masterList.maxCharactersInMSG === 0) {
				getMaxCharCountInSentMsg();
			}
        };

		//submit sms
		vm.submitSMS = function(action, selectedItem) {
			vm.model.smsToSend = selectedItem;
			if(!!vm.model.smsToSend.content && !!vm.model.smsToSend.crew){
            	vm.model.sendSMSRequest = AlertManagerService.setSMSToSend(vm.model.smsToSend);
            	onSendSms();
            }else{
                MessageService.warning(MessageService.MESSAGES.CREWING.MESSAGE_EMPTY_CONTENT);
            }
		};

		function onSendSms() {
            AlertManagerService.sendSMS(vm.model.sendSMSRequest,function(data){
                if(data.success) {
                    $uibModalInstance.close('SUCCESS');
                }
            },
            function(error){
                MessageService.error(error.msg[0]);
            }
        );
        };

    function showLoader(flag) {
      EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
        flag: flag,
        target: 'message',
        animationName: 'crewing-loader'
      });
    }

    function updateGridSearchStartPosition(startPosition) {
      vm.model.searchCriteria.startPosition = startPosition;
    }

    function getNextSetOfRecords() {
      vm.model.lastScrollPosition = $(".fixed_header_table_inner_div").scrollTop();
      vm.model.isElasticLoadingVisible = true;
      if(!vm.model.searchOnGoing){
        vm.model.searchOnGoing = true;
        getAlerts();
      }
    }

    function updateAlertsList(alertList) {

      if(!vm.model.isElasticLoadingVisible && alertList.length>0){
        vm.model.alertList = [];
      }
      angular.forEach(alertList, function (alert) {
        vm.model.alertList.push(alert);
      });

      $timeout(function(){
        $(".fixed_header_table_inner_div").scrollTop(vm.model.lastScrollPosition);
      },1000);
    }

		function getAlerts(){
      showLoader(true);
      AlertManagerService.setAlertSearchCriteria(vm.model.searchCriteria);
			AlertManagerService.getAlerts(function(alertList,startPosition) {
        updateAlertsList(alertList);
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.NEW_ALERT_COUNT);
        vm.model.isElasticLoadingVisible = false;
        updateGridSearchStartPosition(startPosition);
				vm.model.searchPanelToggle = false;
        showLoader(false);
        vm.model.searchOnGoing = false;
			}, function(error) {
				MessageService.error(error);
        showLoader(false);
			});
		};

		vm.markAsInformed = function(){
			markAsInformed(null);
		};

		// submit search and set search results
		function markAsInformed(selectedAlert) {
			vm.model.selectedAlertsForMarkAsInform =[]
			if(!!selectedAlert && selectedAlert!=null){
				vm.model.selectedAlertsForMarkAsInform.push(selectedAlert);
			}else{
				setSelectedAlertList('MARK_AS_INFORMED');
			}
			if(!!vm.model.selectedAlertsForMarkAsInform && vm.model.selectedAlertsForMarkAsInform.length>0){
				AlertManagerService.setMarkAsInformedAlerts(vm.model.selectedAlertsForMarkAsInform);
				AlertManagerService.setMarkAsInformed(function (response) {
	                MessageService.success('Successfully Marked As Informed!');
                    vm.model.searchCriteria.startPosition = 1;
                    vm.model.lastScrollPosition = $(".fixed_header_table_inner_div").scrollTop();
                  if(vm.model.alertList.length == 1){
                    vm.model.alertList = [];
                  }
	                getAlerts();
	                EventManagerService.notifyEventListeners(EventManagerService.EVENT.NEW_ALERT_COUNT);
	            },
	            function (error) {
	                MessageService.error(error);
	            });
			}else{
				MessageService.error("Please Select At Least One Not Informed Alert To Set As Informed.");
			}
		};

		//when click on multiple alert informing sms send
		vm.sendAll = function(){
			vm.model.selectedAlertsForSendAll=[];
			setSelectedAlertList('SEND_ALL');
			if(!!vm.model.selectedAlertsForSendAll && vm.model.selectedAlertsForSendAll.length>0){
				PopupManager.openModal('MULTIPLE_SMS_SEND_POPUP', vm.model.selectedAlertsForSendAll, multiSelectAlertsForSendingSMS);
			}else{
				MessageService.error("Please Select At Least One Crew Alert To Send SMS.");
			}
		};

		function multiSelectAlertsForSendingSMS(sms) {
			 if (!!sms && sms!='CLOSE') {
            	vm.model.sendSMSRequest = sms;
            	if(!!vm.model.sendSMSRequest.crewProfileIdList && vm.model.sendSMSRequest.crewProfileIdList!=null && vm.model.sendSMSRequest.crewProfileIdList.length>0){
            		onSendSms();
            	}else{
            		MessageService.error("No Crew is Found To Send SMS.");
            	}
			}
		}

		function getMaxCharCountInSentMsg() {
			AlertManagerService
					.getSendMsgMaxCharacterCount(
							function(charCount) {
								vm.model.masterList.maxCharactersInMSG = charCount === null ? 0
										: charCount.paramValue;
							},
							function() {
								console
										.log('App Param Send Msg Character Count retrieval error');
							});
		};

		vm.changeSearchField = function(searchParams, flag) {
			if (flag === 'crewType') {
				vm.model.masterList.crewDetails = loadCrewList(searchParams.crewType);
			}
			if (flag == "fromDate") {
				var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
	        	if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
	        		searchParams.toDate = tempFromDate;
	        	}
			}
		};

		vm.changeEditorField = function(formModel, flag){
			if (flag === 'crewType') {
				var crewType = vm.model.newSMS.crewTypeCode;
				if(!!formModel){
					crewType = formModel.crewTypeCode;
				}
				vm.model.masterList.crewDetails = loadCrewList(crewType);
			}
		};

		// get crew List
		function loadCrewList(crewType) {
			var param = {};
			param.crewType = '';
			param.active = true;
			if (!!crewType) {
				param.crewType = crewType.crewTypeCode;
				CommonMasterData.loadCrewList(param, function(response) {
					vm.model.masterList.crewDetails = crewScheduleService
							.adaptCrewList(response);
				}, function() {
					console.log('Crew list retrieval error');
				});
			}else{
				vm.model.masterList.crewDetails = null;
			}
		};

        //set All alerts as selected
        function setAllAlertsAsSelected(){
        	vm.model.allAlertSelected = !vm.model.allAlertSelected;
        	if(!!vm.model.alertList && vm.model.alertList.length>0){
        		for(var i=0; i<vm.model.alertList.length;i++){
        			vm.model.alertList[i].isSelected = vm.model.allAlertSelected;
        		}
        	}
        	vm.model.selectedAlertsForMarkAsInform =[];
        	setSelectedAlertList('MARK_AS_INFORMED');
        	vm.model.selectedAlertsForSendAll=[];
        	setSelectedAlertList('SEND_ALL');
        };

        function setSelectedAlertList(flag){
        	if(!!vm.model.alertList && vm.model.alertList.length>0){
        		for(var i=0; i<vm.model.alertList.length;i++){
        			if(vm.model.alertList[i].isSelected){
        				if(flag=='MARK_AS_INFORMED' && vm.model.alertList[i].isHandled=='N'){
        	        		vm.model.selectedAlertsForMarkAsInform.push(vm.model.alertList[i]);
        	        	}else if(flag=='SEND_ALL' && vm.model.alertList[i].category =='Crew Alerts'){
        	        		vm.model.selectedAlertsForSendAll.push(vm.model.alertList[i]);
        	        	}else if(flag=='SEND_ALL' && vm.model.alertList[i].category =='System Alerts'){
        	        	  for (var key in vm.model.alertList[i].crewProfileCol) {
                        if (vm.model.alertList[i].crewProfileCol.hasOwnProperty(key)) {
                          angular.forEach(vm.model.alertList[i].crewProfileCol[key], function (crewProfile) {
                            var alert = angular.copy(vm.model.alertList[i]);
                            alert.crewName = crewProfile.firstName + " " + crewProfile.lastName;
                            alert.crewProfileId = crewProfile.crewProfileId;
                            alert.crewTypeCode = crewProfile.crewTypeCode;
                            vm.model.selectedAlertsForSendAll.push(alert);
                          });
                        }
                      }
                    }
        			}
        		}
        	}
        };

      var tabLocalData = StorageServices.getTabData('alertManager');
      if (!!tabLocalData && !!tabLocalData.alertParams) {
        vm.model.searchCriteria.fromDate = tabLocalData.alertParams.fromDate;
        vm.model.searchCriteria.toDate = tabLocalData.alertParams.toDate;
        vm.model.searchCriteria.alertCategory = null;
        vm.model.initialSearchDone = true;
        vm.model.alertList = [];
        vm.model.lastScrollPosition = 0;
        StorageServices.clearTabData('alertManager');
        setDefault();
        getAlerts();
      }

		// get master data list
		(function() {
			// base list
			CommonMasterData.getCrewBaseList(function(crewBases) {
				vm.model.masterList.crewBaseList = crewBases;
			}, function() {
				console.log('Crew Base List retrieval error');
			});
			// crew types
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				vm.model.masterList.crewTypes = crewTypes;
			}, function() {
				console.log('Crew types retrieval error');
			});
			// crew category
			CommonMasterData.getAlertCategoryList(function(categories) {
				vm.model.masterList.categoryList = categories;
			}, function() {
				console.log('Crew Category List retrieval error');
			});
			// aircraft types
			CommonMasterData.getAircraftTypeList(function(aircrafts) {
				vm.model.masterList.aircraftTypes = aircrafts;
			}, function() {
				console.log('Aircraft types retrieval error');
			});

      AlertManagerService.getAlertCreatedByList(function(response) {
        vm.model.masterList.alertCreatedByList = response;
      }, function() {
        console.log('Alert Created By error');
      });

      AlertManagerService.getAlertTemplateCodeList(function(response) {
        vm.model.masterList.alertTemplateCodeList = response;
      }, function() {
        console.log('Alert Created By error');
      });

			// max msg count in send msg
			getMaxCharCountInSentMsg();
		})();

	}
}());
